import Instance from "../../../../Axios";

// New Actions for the app

const UpdateSetor = (yData, id) => async (dispatch) => {
  await Instance()
    .put(`/energias/setores/edit/${id}`, { yData })
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: "UPDATE_SETOR", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default UpdateSetor;
